// extracted by mini-css-extract-plugin
export default {"dropzone":"new-project-page_dropzone__IGOXY","dragActive":"new-project-page_dragActive__JTEG0"};